import { useTranslation } from 'react-i18next'

export function ErrorState() {
	const { t } = useTranslation('common')

	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-3 px-6 text-center">
			<p className="text-lg font-medium text-grey-800">{t('login.error.title')}</p>
			<p className="max-w-sm text-sm text-grey-500">{t('login.error.body')}</p>
			<button
				type="button"
				onClick={() => window.location.reload()}
				className="mt-2 cursor-pointer rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
			>
				{t('error_boundary.reload')}
			</button>
		</div>
	)
}
